// import React, { useRef, useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import "./InpaintingPage.css";
// import { Link } from "react-router-dom";

// function InpaintingPage() {
//   const canvasRef = useRef(null);
//   const imageRef = useRef(null);
//   const maskCanvasRef = useRef(document.createElement('canvas'));
//   const [isDrawing, setIsDrawing] = useState(false);
//   const [mask, setMask] = useState(null);
//   const [imageUrl, setImageUrl] = useState(null);
//   const [generatedImages, setGeneratedImages] = useState([]);
//   const [error, setError] = useState(null);
//   const [isGenerating, setIsGenerating] = useState(false);
//   const [inpaintFill, setInpaintFill] = useState(1);
  
//   // Drawing tools state
//   const [positivePrompt, setPositivePrompt] = useState("");
//   const [negativePrompt, setNegativePrompt] = useState("");
//   const [brushSize, setBrushSize] = useState(20);
//   const [currentColor, setCurrentColor] = useState("rgba(255, 0, 0, 1)");
//   const [isErasing, setIsErasing] = useState(false);
//   const [drawingHistory, setDrawingHistory] = useState([]);
//   const [historyIndex, setHistoryIndex] = useState(-1);
  
//   // Color options
//   const colorOptions = [
//     { name: "Red", value: "rgba(255, 0, 0, 1)" },
//     { name: "Green", value: "rgba(0, 255, 0, 1)" },
//     { name: "Blue", value: "rgba(0, 0, 255, 1)" },
//     { name: "Yellow", value: "rgba(255, 255, 0, 1)" },
//   ];

//   // Handle image upload
//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = () => {
//         setImageUrl(reader.result);
//         setDrawingHistory([]);
//         setHistoryIndex(-1);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Initialize canvas when image loads
//   useEffect(() => {
//     if (!imageUrl || !imageRef.current) return;
  
//     const canvas = canvasRef.current;
//     const img = imageRef.current;
    
//     img.onload = () => {
//       canvas.width = img.naturalWidth;
//       canvas.height = img.naturalHeight;
//       maskCanvasRef.current.width = img.naturalWidth;
//       maskCanvasRef.current.height = img.naturalHeight;
//       const ctx = canvas.getContext('2d');
      
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
//       ctx.globalCompositeOperation = 'source-over';
//       ctx.imageSmoothingEnabled = false;
//     };
//   }, [imageUrl]);

//   // Save canvas state to history
//   const saveToHistory = useCallback(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
    
//     const history = drawingHistory.slice(0, historyIndex + 1);
//     const newHistory = [...history, canvas.toDataURL()];
    
//     setDrawingHistory(newHistory);
//     setHistoryIndex(newHistory.length - 1);
//   }, [drawingHistory, historyIndex]);

//   // Drawing functions
//   const startDrawing = (e) => {
//     if (!imageUrl) return;
    
//     setIsDrawing(true);
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     const rect = canvas.getBoundingClientRect();
//     const x = (e.clientX - rect.left) * (canvas.width / rect.width);
//     const y = (e.clientY - rect.top) * (canvas.height / rect.height);
    
//     ctx.beginPath();
//     ctx.moveTo(x, y);
//     ctx.strokeStyle = isErasing ? "rgba(0, 0, 0, 1)" : currentColor;
//     ctx.lineWidth = brushSize;
//     ctx.lineCap = 'round';
//     ctx.lineJoin = 'round';
//     ctx.globalCompositeOperation = isErasing ? 'destination-out' : 'source-over';
//     saveToHistory();
//   };

//   const draw = (e) => {
//     if (!isDrawing || !imageUrl) return;
    
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     const rect = canvas.getBoundingClientRect();
//     const x = (e.clientX - rect.left) * (canvas.width / rect.width);
//     const y = (e.clientY - rect.top) * (canvas.height / rect.height);
    
//     ctx.lineTo(x, y);
//     ctx.stroke();
//     ctx.beginPath();
//     ctx.moveTo(x, y);
//   };

//   const stopDrawing = () => {
//     if (!isDrawing) return;
//     setIsDrawing(false);
//     updateMask();
//   };

//   // Update mask from canvas
//   // const updateMask = useCallback(() => {
//   //   const canvas = canvasRef.current;
//   //   const maskCanvas = maskCanvasRef.current;
//   //   const maskCtx = maskCanvas.getContext('2d');
    
//   //   // Start with transparent mask (will become black)
//   //   maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
    
//   //   // For inpainting, we need:
//   //   // - Fully white pixels (255,255,255) = areas to inpaint
//   //   // - Fully black pixels (0,0,0) = areas to keep
    
//   //   // Get the drawn content from main canvas
//   //   const drawnContent = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
//   //   const drawnData = drawnContent.data;
    
//   //   // Create new mask image data
//   //   const maskData = maskCtx.createImageData(maskCanvas.width, maskCanvas.height);
    
//   //   for (let i = 0; i < drawnData.length; i += 4) {
//   //     // Check alpha channel - only pixels actually drawn on (non-transparent)
//   //     if (drawnData[i+3] > 0) {
//   //       // Set mask pixels to white where user drew
//   //       maskData.data[i] = 255;     // R
//   //       maskData.data[i+1] = 255;   // G
//   //       maskData.data[i+2] = 255;   // B
//   //       maskData.data[i+3] = 255;   // A
//   //     } else {
//   //       // Set all other pixels to black
//   //       maskData.data[i] = 0;       // R
//   //       maskData.data[i+1] = 0;     // G
//   //       maskData.data[i+2] = 0;     // B
//   //       maskData.data[i+3] = 255;   // A
//   //     }
//   //   }
    
//   //   maskCtx.putImageData(maskData, 0, 0);
//   //   setMask(maskCanvas.toDataURL('image/png'));
//   // }, []);


//   const updateMask = useCallback(() => {
//     const canvas = canvasRef.current;
//     const maskCanvas = maskCanvasRef.current;
//     const maskCtx = maskCanvas.getContext('2d');
    
//     // 1. Start with completely black mask (keep everything)
//     maskCtx.fillStyle = 'black';
//     maskCtx.fillRect(0, 0, maskCanvas.width, maskCanvas.height);
    
//     // 2. Get ONLY the user's drawings (not the background image)
//     const tempCanvas = document.createElement('canvas');
//     tempCanvas.width = canvas.width;
//     tempCanvas.height = canvas.height;
//     const tempCtx = tempCanvas.getContext('2d');
    
//     // Draw just the strokes (ignore the background image)
//     tempCtx.drawImage(canvas, 0, 0);
    
//     // 3. Convert drawings to white in the mask
//     const drawnData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height).data;
//     const maskData = maskCtx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
    
//     for (let i = 0; i < drawnData.length; i += 4) {
//       // Only convert pixels that were actually drawn on (non-transparent)
//       if (drawnData[i+3] > 0) {
//         maskData.data[i] = 255;   // R
//         maskData.data[i+1] = 255; // G
//         maskData.data[i+2] = 255; // B
//         // Keep alpha at 255
//       }
//     }
    
//     maskCtx.putImageData(maskData, 0, 0);
//     setMask(maskCanvas.toDataURL('image/png'));
//   }, []);
//   // const updateMask = useCallback(() => {
//   //   const canvas = canvasRef.current;
//   //   const maskCanvas = maskCanvasRef.current;
//   //   const maskCtx = maskCanvas.getContext('2d');
    
//   //   maskCtx.fillStyle = 'black';
//   //   maskCtx.fillRect(0, 0, maskCanvas.width, maskCanvas.height);
//   //   maskCtx.drawImage(canvas, 0, 0);
    
//   //   const imageData = maskCtx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
//   //   const data = imageData.data;
    
//   //   for (let i = 0; i < data.length; i += 4) {
//   //     if (data[i] > 0 || data[i+1] > 0 || data[i+2] > 0) {
//   //       data[i] = data[i+1] = data[i+2] = 255;
//   //       data[i+3] = 255;
//   //     }
//   //   }
    
//   //   maskCtx.putImageData(imageData, 0, 0);
//   //   setMask(maskCanvas.toDataURL('image/png'));
//   // }, []);

//   const clearCanvas = () => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     ctx.clearRect(0, 0, canvas.width, canvas.height);
//     setMask(null);
//     saveToHistory();
//   };

//   const undoDrawing = () => {
//     if (historyIndex <= 0) return;
    
//     const newIndex = historyIndex - 1;
//     setHistoryIndex(newIndex);
    
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     const img = new Image();
    
//     img.onload = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       ctx.drawImage(img, 0, 0);
//       updateMask();
//     };
//     img.src = drawingHistory[newIndex];
//   };

//   const redoDrawing = () => {
//     if (historyIndex >= drawingHistory.length - 1) return;
    
//     const newIndex = historyIndex + 1;
//     setHistoryIndex(newIndex);
    
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     const img = new Image();
    
//     img.onload = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       ctx.drawImage(img, 0, 0);
//       updateMask();
//     };
//     img.src = drawingHistory[newIndex];
//   };

//   const handleInpaint = async () => {
//     if (!imageUrl || !mask) {
//       setError("Please upload an image and create a mask first");
//       return;
//     }
  
//     const maskCanvas = maskCanvasRef.current;
//     const maskCtx = maskCanvas.getContext('2d');
//     const imageData = maskCtx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
//     const data = imageData.data;
//     let whitePixels = 0;
    
//     for (let i = 0; i < data.length; i += 4) {
//       if (data[i] === 255) whitePixels++;
//     }
    
//     if (whitePixels < 100) {
//       setError("Mask area is too small. Please draw a larger area to inpaint.");
//       return;
//     }
  
//     setIsGenerating(true);
//     setError(null);
  
//     try {
//       const formData = new FormData();
//       const imageBlob = await fetch(imageUrl).then(r => r.blob());
//       const maskBlob = await fetch(mask).then(r => r.blob());
      
//       formData.append("image", imageBlob, "image.png");
//       formData.append("mask", maskBlob, "mask.png");
//       formData.append("positive_prompt", positivePrompt);
//       formData.append("negative_prompt", negativePrompt);
//       formData.append("inpaint_fill", inpaintFill.toString());
//       formData.append("steps", "20");
//       formData.append("cfg_scale", "7.5");
//       formData.append("sampler_index", "Euler a");

//       const response = await axios.post("/inpaint", formData, {
//         headers: { "Content-Type": "multipart/form-data" }
//       });

//       if (response.data.image_url) {
//         const proxiedUrl = response.data.image_url.replace(
//           "http://216.48.178.59:8000",
//           "https://revampspaces.in"
//         );
//         setImageUrl(proxiedUrl);
//         setGeneratedImages(prev => [...prev, proxiedUrl]);

//         setTimeout(() => {
//           setIsGenerating(false);
//         }, 100);
//       } else if (response.data.error) {
//         setError(response.data.error);
//         setIsGenerating(false);
//       }
//     } catch (error) {
//       console.error("Inpainting error:", error);
//       setError(error.response?.data?.error || "Inpainting failed. Please try again.");
//       setIsGenerating(false);
//     }
//   };

//   return (
//     <div className="inpainting-container">
//       {isGenerating && (
//         <div className="loader-overlay">
//           <div className="cardloading">
//             <div className="loaderloading">
//               <p>Creating</p>
//               <div className="wordsloading">
//                 <span className="word">walls</span>
//                 <span className="word">paints</span>
//                 <span className="word">furnishins</span>
//                 <span className="word">lights</span>
//                 <span className="word">flooring</span>
//                 <span className="word">ceiling</span>
//                 <span className="word">workers</span>
//                 <span className="word">GenAi-image</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <header className="inpainting-header">
//         <h1>AI Inpainting Tool</h1>
//         <Link to="/" className="home-button">Back to Home</Link>
//       </header>
      
//       <div className="inpainting-layout">
//         <div className="controls-panel">
//           <div className="upload-section">
//             <h3>Upload Image</h3>
//             <label className="file-upload">
//               <input 
//                 type="file" 
//                 accept="image/*" 
//                 onChange={handleImageUpload} 
//                 aria-label="Upload image"
//               />
//               Choose File
//             </label>
//           </div>
          
//           <div className="prompts-section">
//             <h3>Prompts</h3>
//             <div className="prompt-group">
//               <label htmlFor="positive-prompt">Positive Prompt</label>
//               <textarea
//                 id="positive-prompt"
//                 value={positivePrompt}
//                 onChange={(e) => setPositivePrompt(e.target.value)}
//                 placeholder="What you want to generate..."
//                 aria-label="Positive prompt"
//               />
//             </div>
            
//             <div className="prompt-group">
//               <label htmlFor="negative-prompt">Negative Prompt</label>
//               <textarea
//                 id="negative-prompt"
//                 value={negativePrompt}
//                 onChange={(e) => setNegativePrompt(e.target.value)}
//                 placeholder="What you want to avoid..."
//                 aria-label="Negative prompt"
//               />
//             </div>
//           </div>
          
//           <div className="tools-section">
//             <h3>Mask Tools</h3>
            
//             <div className="tool-group">
//               <label htmlFor="brush-size">Brush Size: {brushSize}px</label>
//               <input 
//                 id="brush-size"
//                 type="range" 
//                 min="5" 
//                 max="50" 
//                 value={brushSize}
//                 onChange={(e) => setBrushSize(Number(e.target.value))}
//                 aria-label="Brush size"
//               />
//             </div>
            
//             <div className="tool-group">
//               <label>Brush Color</label>
//               <div className="color-palette" role="group" aria-label="Color palette">
//                 {colorOptions.map((color) => (
//                   <button
//                     key={color.name}
//                     className={`color-swatch ${currentColor === color.value ? 'active' : ''}`}
//                     style={{ backgroundColor: color.value }}
//                     onClick={() => {
//                       setCurrentColor(color.value);
//                       setIsErasing(false);
//                     }}
//                     title={color.name}
//                     aria-label={color.name}
//                   />
//                 ))}
//               </div>
//             </div>
            
//             <div className="tool-group">
//               <button 
//                 className={`tool-button ${isErasing ? 'active' : ''}`}
//                 onClick={() => setIsErasing(!isErasing)}
//                 aria-pressed={isErasing}
//                 aria-label={isErasing ? 'Switch to brush' : 'Use eraser'}
//               >
//                 {isErasing ? '✏️ Switch to Brush' : '🧽 Use Eraser'}
//               </button>
//             </div>
            
//             <div className="tool-group">
//               <label htmlFor="inpaint-mode">Inpaint Mode</label>
//               <select 
//                 id="inpaint-mode"
//                 value={inpaintFill} 
//                 onChange={(e) => setInpaintFill(Number(e.target.value))}
//                 aria-label="Inpaint mode"
//               >
//                 <option value="1">Original (keep unmasked areas)</option>
//                 <option value="2">Fill (replace entire area)</option>
//               </select>
//             </div>

//             <div className="tool-group history-buttons">
//               <button 
//                 onClick={undoDrawing} 
//                 disabled={historyIndex <= 0}
//                 aria-label="Undo"
//               >
//                 ↩ Undo
//               </button>
//               <button 
//                 onClick={redoDrawing} 
//                 disabled={historyIndex >= drawingHistory.length - 1}
//                 aria-label="Redo"
//               >
//                 ↪ Redo
//               </button>
//             </div>
//           </div>
          
//           <div className="action-buttons">
//             <button 
//               className="clear-button"
//               onClick={clearCanvas}
//               disabled={!imageUrl}
//               aria-label="Clear mask"
//             >
//               Clear Mask
//             </button>
//             <button 
//               className="inpaint-button"
//               onClick={handleInpaint} 
//               disabled={isGenerating || !imageUrl || !mask}
//               aria-label="Generate inpainting"
//             >
//               {isGenerating ? "⏳ Processing..." : "🎨 Generate Inpaint"}
//             </button>
//           </div>
          
//           {error && <div className="error-message" role="alert">{error}</div>}
//         </div>
        
//         <div className="canvas-panel">
//           <div className="canvas-header">
//             <h3>Drawing Canvas</h3>
//             <p>{imageUrl ? "Draw on the image to create mask" : "Please upload an image to begin"}</p>
//           </div>
          
//           <div className="canvas-wrapper">
//             {imageUrl ? (
//               <>
//                 <img
//                   ref={imageRef}
//                   src={imageUrl}
//                   alt="Original"
//                   style={{ display: 'none' }}
//                 />
//                 <canvas
//                   ref={canvasRef}
//                   className="mask-canvas"
//                   onMouseDown={startDrawing}
//                   onMouseMove={draw}
//                   onMouseUp={stopDrawing}
//                   onMouseLeave={stopDrawing}
//                   onTouchStart={(e) => {
//                     e.preventDefault();
//                     startDrawing(e.touches[0]);
//                   }}
//                   onTouchMove={(e) => {
//                     e.preventDefault();
//                     draw(e.touches[0]);
//                   }}
//                   onTouchEnd={(e) => {
//                     e.preventDefault();
//                     stopDrawing();
//                   }}
//                   style={{
//                     backgroundImage: `url(${imageUrl})`,
//                     backgroundSize: 'contain',
//                     backgroundRepeat: 'no-repeat',
//                     backgroundPosition: 'center'
//                   }}
//                   aria-label="Drawing canvas"
//                 />
//               </>
//             ) : (
//               <div className="empty-canvas">
//                 <p>No image uploaded yet</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
      
//       {generatedImages.length > 0 && (
//         <div className="results-section">
//           <h3>Generated Results</h3>
//           <div className="results-grid">
//             {generatedImages.map((image, index) => (
//               <div key={index} className="result-item">
//                 <img 
//                   src={image} 
//                   alt={`Generated ${index + 1}`} 
//                   onError={(e) => e.target.style.display = 'none'}
//                   loading="lazy"
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default InpaintingPage;








import React, { useRef, useState, useEffect, useCallback } from "react";
import axios from "axios";
import "./InpaintingPage.css";
import { Link } from "react-router-dom";

function InpaintingPage() {
  const canvasRef = useRef(null);
  const imageRef = useRef(null);
  const maskCanvasRef = useRef(document.createElement('canvas'));
  const [isDrawing, setIsDrawing] = useState(false);
  const [mask, setMask] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [generatedImages, setGeneratedImages] = useState([]);
  const [error, setError] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [inpaintFill, setInpaintFill] = useState(1);
  
  // Drawing tools state
  const [positivePrompt, setPositivePrompt] = useState("");
  const [negativePrompt, setNegativePrompt] = useState("");
  const [brushSize, setBrushSize] = useState(20);
  const [currentColor, setCurrentColor] = useState("rgba(255, 0, 0, 1)");
  const [isErasing, setIsErasing] = useState(false);
  const [drawingHistory, setDrawingHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);
  
  // Color options
  const colorOptions = [
    { name: "Red", value: "rgba(255, 0, 0, 1)" },
    { name: "Green", value: "rgba(0, 255, 0, 1)" },
    { name: "Blue", value: "rgba(0, 0, 255, 1)" },
    { name: "Yellow", value: "rgba(255, 255, 0, 1)" },
  ];

  // Handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageUrl(reader.result);
        setDrawingHistory([]);
        setHistoryIndex(-1);
        setMask(null);  // Reset mask when uploading a new image
      };
      reader.readAsDataURL(file);
    }
  };

  // Initialize canvas when image loads
  useEffect(() => {
    if (!imageUrl || !imageRef.current) return;
  
    const canvas = canvasRef.current;
    const img = imageRef.current;
    
    img.onload = () => {
      // Set canvas and mask canvas dimensions
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      maskCanvasRef.current.width = img.naturalWidth;
      maskCanvasRef.current.height = img.naturalHeight;
      
      // Don't draw the image on the canvas - we'll use CSS background-image instead
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'source-over';
      ctx.imageSmoothingEnabled = false;
      
      // Clear the mask canvas
      const maskCtx = maskCanvasRef.current.getContext('2d');
      maskCtx.clearRect(0, 0, maskCanvasRef.current.width, maskCanvasRef.current.height);
      maskCtx.fillStyle = 'black';
      maskCtx.fillRect(0, 0, maskCanvasRef.current.width, maskCanvasRef.current.height);
    };
  }, [imageUrl]);

  // Save canvas state to history
  const saveToHistory = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const history = drawingHistory.slice(0, historyIndex + 1);
    const newHistory = [...history, canvas.toDataURL()];
    
    setDrawingHistory(newHistory);
    setHistoryIndex(newHistory.length - 1);
  }, [drawingHistory, historyIndex]);

  // Drawing functions
  const startDrawing = (e) => {
    if (!imageUrl) return;
    
    setIsDrawing(true);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);
    
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.strokeStyle = isErasing ? "rgba(0, 0, 0, 0)" : currentColor;
    ctx.lineWidth = brushSize;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.globalCompositeOperation = isErasing ? 'destination-out' : 'source-over';
    saveToHistory();
  };

  const draw = (e) => {
    if (!isDrawing || !imageUrl) return;
    
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);
    
    ctx.lineTo(x, y);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const stopDrawing = () => {
    if (!isDrawing) return;
    setIsDrawing(false);
    updateMask();
  };

  // Update mask from canvas - FIXED VERSION
  const updateMask = useCallback(() => {
    const canvas = canvasRef.current;
    const maskCanvas = maskCanvasRef.current;
    const maskCtx = maskCanvas.getContext('2d');
    
    // Start with black mask (areas to keep)
    maskCtx.fillStyle = 'black';
    maskCtx.fillRect(0, 0, maskCanvas.width, maskCanvas.height);
    
    // Get the drawing data from the main canvas
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    
    // Create new mask image data
    const maskImageData = maskCtx.createImageData(maskCanvas.width, maskCanvas.height);
    const maskData = maskImageData.data;
    
    // For each pixel in the drawing canvas
    for (let i = 0; i < data.length; i += 4) {
      // Check if this pixel has been drawn on (non-transparent)
      if (data[i+3] > 0) {
        // Set mask pixels to white (255,255,255) where user drew
        maskData[i] = 255;     // R
        maskData[i+1] = 255;   // G
        maskData[i+2] = 255;   // B
        maskData[i+3] = 255;   // A fully opaque
      } else {
        // Set all other pixels to black (0,0,0)
        maskData[i] = 0;       // R
        maskData[i+1] = 0;     // G
        maskData[i+2] = 0;     // B
        maskData[i+3] = 255;   // A fully opaque
      }
    }
    
    // Put the processed mask data back to the mask canvas
    maskCtx.putImageData(maskImageData, 0, 0);
    
    // Set the mask state with the mask canvas data URL
    setMask(maskCanvas.toDataURL('image/png'));
  }, []);

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // Reset mask to all black (nothing to inpaint)
    const maskCanvas = maskCanvasRef.current;
    const maskCtx = maskCanvas.getContext('2d');
    maskCtx.fillStyle = 'black';
    maskCtx.fillRect(0, 0, maskCanvas.width, maskCanvas.height);
    
    setMask(null);
    saveToHistory();
  };

  const undoDrawing = () => {
    if (historyIndex <= 0) return;
    
    const newIndex = historyIndex - 1;
    setHistoryIndex(newIndex);
    
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      updateMask();
    };
    img.src = drawingHistory[newIndex];
  };

  const redoDrawing = () => {
    if (historyIndex >= drawingHistory.length - 1) return;
    
    const newIndex = historyIndex + 1;
    setHistoryIndex(newIndex);
    
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      updateMask();
    };
    img.src = drawingHistory[newIndex];
  };

  const handleInpaint = async () => {
    if (!imageUrl || !mask) {
      setError("Please upload an image and create a mask first");
      return;
    }
  
    const maskCanvas = maskCanvasRef.current;
    const maskCtx = maskCanvas.getContext('2d');
    const imageData = maskCtx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
    const data = imageData.data;
    let whitePixels = 0;
    
    // Count white pixels to ensure the mask is large enough
    for (let i = 0; i < data.length; i += 4) {
      if (data[i] === 255 && data[i+1] === 255 && data[i+2] === 255) {
        whitePixels++;
      }
    }
    
    if (whitePixels < 100) {
      setError("Mask area is too small. Please draw a larger area to inpaint.");
      return;
    }
  
    setIsGenerating(true);
    setError(null);
  
    try {
      const formData = new FormData();
      const imageBlob = await fetch(imageUrl).then(r => r.blob());
      const maskBlob = await fetch(mask).then(r => r.blob());
      
      formData.append("image", imageBlob, "image.png");
      formData.append("mask", maskBlob, "mask.png");
      formData.append("positive_prompt", positivePrompt);
      formData.append("negative_prompt", negativePrompt);
      formData.append("inpaint_fill", inpaintFill.toString());
      formData.append("steps", "20");
      formData.append("cfg_scale", "7.5");
      formData.append("sampler_index", "Euler a");

      const response = await axios.post("/inpaint", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response.data.image_url) {
        // Process the response
        const proxiedUrl = response.data.image_url.replace(
          "http://216.48.178.59:8000",
          "https://revampspaces.in"
        );
        setImageUrl(proxiedUrl);
        setGeneratedImages(prev => [...prev, proxiedUrl]);

        setTimeout(() => {
          setIsGenerating(false);
        }, 100);
      } else if (response.data.error) {
        setError(response.data.error);
        setIsGenerating(false);
      }
    } catch (error) {
      console.error("Inpainting error:", error);
      setError(error.response?.data?.error || "Inpainting failed. Please try again.");
      setIsGenerating(false);
    }
  };

  return (
    <div className="inpainting-container">
      {isGenerating && (
        <div className="loader-overlay">
          <div className="cardloading">
            <div className="loaderloading">
              <p>Creating</p>
              <div className="wordsloading">
                <span className="word">walls</span>
                <span className="word">paints</span>
                <span className="word">furnishins</span>
                <span className="word">lights</span>
                <span className="word">flooring</span>
                <span className="word">ceiling</span>
                <span className="word">workers</span>
                <span className="word">GenAi-image</span>
              </div>
            </div>
          </div>
        </div>
      )}

      <header className="inpainting-header">
        <h1>AI Inpainting Tool</h1>
        <Link to="/tools" className="home-button">Back to Home</Link>
      </header>
      
      <div className="inpainting-layout">
        <div className="controls-panel">
          <div className="upload-section">
            <h3>Upload Image</h3>
            <label className="file-upload">
              <input 
                type="file" 
                accept="image/*" 
                onChange={handleImageUpload} 
                aria-label="Upload image"
              />
              Choose File
            </label>
          </div>
          
          <div className="prompts-section">
            <h3>Prompts</h3>
            <div className="prompt-group">
              <label htmlFor="positive-prompt">Positive Prompt</label>
              <textarea
                id="positive-prompt"
                value={positivePrompt}
                onChange={(e) => setPositivePrompt(e.target.value)}
                placeholder="What you want to generate..."
                aria-label="Positive prompt"
              />
            </div>
            
            <div className="prompt-group">
              <label htmlFor="negative-prompt">Negative Prompt</label>
              <textarea
                id="negative-prompt"
                value={negativePrompt}
                onChange={(e) => setNegativePrompt(e.target.value)}
                placeholder="What you want to avoid..."
                aria-label="Negative prompt"
              />
            </div>
          </div>
          
          <div className="tools-section">
            <h3>Mask Tools</h3>
            
            <div className="tool-group">
              <label htmlFor="brush-size">Brush Size: {brushSize}px</label>
              <input 
                id="brush-size"
                type="range" 
                min="5" 
                max="50" 
                value={brushSize}
                onChange={(e) => setBrushSize(Number(e.target.value))}
                aria-label="Brush size"
              />
            </div>
            
            <div className="tool-group">
              <label>Brush Color</label>
              <div className="color-palette" role="group" aria-label="Color palette">
                {colorOptions.map((color) => (
                  <button
                    key={color.name}
                    className={`color-swatch ${currentColor === color.value ? 'active' : ''}`}
                    style={{ backgroundColor: color.value }}
                    onClick={() => {
                      setCurrentColor(color.value);
                      setIsErasing(false);
                    }}
                    title={color.name}
                    aria-label={color.name}
                  />
                ))}
              </div>
            </div>
            
            <div className="tool-group">
              <button 
                className={`tool-button ${isErasing ? 'active' : ''}`}
                onClick={() => setIsErasing(!isErasing)}
                aria-pressed={isErasing}
                aria-label={isErasing ? 'Switch to brush' : 'Use eraser'}
              >
                {isErasing ? '✏️ Switch to Brush' : '🧽 Use Eraser'}
              </button>
            </div>
            
            <div className="tool-group">
              <label htmlFor="inpaint-mode">Inpaint Mode</label>
              <select 
                id="inpaint-mode"
                value={inpaintFill} 
                onChange={(e) => setInpaintFill(Number(e.target.value))}
                aria-label="Inpaint mode"
              >
                <option value="1">Original (keep unmasked areas)</option>
                <option value="2">Fill (replace entire area)</option>
              </select>
            </div>

            <div className="tool-group history-buttons">
              <button 
                onClick={undoDrawing} 
                disabled={historyIndex <= 0}
                aria-label="Undo"
              >
                ↩ Undo
              </button>
              <button 
                onClick={redoDrawing} 
                disabled={historyIndex >= drawingHistory.length - 1}
                aria-label="Redo"
              >
                ↪ Redo
              </button>
            </div>
          </div>
          
          <div className="action-buttons">
            <button 
              className="clear-button"
              onClick={clearCanvas}
              disabled={!imageUrl}
              aria-label="Clear mask"
            >
              Clear Mask
            </button>
            <button 
              className="inpaint-button"
              onClick={handleInpaint} 
              disabled={isGenerating || !imageUrl || !mask}
              aria-label="Generate inpainting"
            >
              {isGenerating ? "⏳ Processing..." : "🎨 Generate Inpaint"}
            </button>
          </div>
          
          {error && <div className="error-message" role="alert">{error}</div>}
        </div>
        
        <div className="canvas-panel">
          <div className="canvas-header">
            <h3>Drawing Canvas</h3>
            <p>{imageUrl ? "Draw on the image to create mask" : "Please upload an image to begin"}</p>
          </div>
          
          <div className="canvas-wrapper">
            {imageUrl ? (
              <>
                <img
                  ref={imageRef}
                  src={imageUrl}
                  alt="Original"
                  style={{ display: 'none' }}
                />
                <canvas
                  ref={canvasRef}
                  className="mask-canvas"
                  onMouseDown={startDrawing}
                  onMouseMove={draw}
                  onMouseUp={stopDrawing}
                  onMouseLeave={stopDrawing}
                  onTouchStart={(e) => {
                    e.preventDefault();
                    startDrawing(e.touches[0]);
                  }}
                  onTouchMove={(e) => {
                    e.preventDefault();
                    draw(e.touches[0]);
                  }}
                  onTouchEnd={(e) => {
                    e.preventDefault();
                    stopDrawing();
                  }}
                  style={{
                    backgroundImage: `url(${imageUrl})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                  }}
                  aria-label="Drawing canvas"
                />
              </>
            ) : (
              <div className="empty-canvas">
                <p>No image uploaded yet</p>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {generatedImages.length > 0 && (
        <div className="results-section">
          <h3>Generated Results</h3>
          <div className="results-grid">
            {generatedImages.map((image, index) => (
              <div key={index} className="result-item">
                <img 
                  src={image} 
                  alt={`Generated ${index + 1}`} 
                  onError={(e) => e.target.style.display = 'none'}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default InpaintingPage;